import defaultPalette from "../../defaults/palette";
import defaultBreakPoints from "../../defaults/breakPoints";
import config from "../jss/State";
export default function Init(options) {
    config.init({
        palette: {
            ...defaultPalette,
            ...((options === null || options === void 0 ? void 0 : options.palette) || {}),
        },
        breakpoints: {
            ...defaultBreakPoints,
            ...((options === null || options === void 0 ? void 0 : options.breakpoints) || {}),
        },
    });
}
